const initialState = {
  tickets: {
    visibleFields: "",
    filterFields: "",
  },
  myTickets: {
    visibleFields: "",
    filterFields: "",
  },
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TICKETS_FILTER":
      return {
        ...state,
        [action.payload.key]: {
          visibleFields: action.payload.visibleFields || "",
          filterFields: action.payload.filterFields || "",
        },
      };
    case "RESET_ALL_TICKETS_FILTER":
      return {
        ...state,
        tickets: {
          visibleFields: "",
          filterFields: "",
        },
        myTickets: {
          visibleFields: "",
          filterFields: "",
        },
      };
    default:
      return state;
  }
};

export default filterReducer;
